import asyncComponent from '../common/utils/async-component';
import Logout from './components/logout';

const Login = asyncComponent(async () => import('./components/login'));
const LoginCliComplete = asyncComponent(async () => import('./components/login-cli-complete'));
const Signup = asyncComponent(async () => import('./components/signup'));
const ResetPassword = asyncComponent(async () => import('./components/reset-password'));
const ForgotPassword = asyncComponent(async () => import('./components/forgot-password'));
const CheckEmail = asyncComponent(async () => import('./components/check-email'));
const AccountSettings = asyncComponent(async () => import('./components/account-settings'));
const PersonalAccessTokens = asyncComponent(async () => import('./components/personal-access-tokens'));
const PersonalAccessTokenCreate = asyncComponent(async () => import('./components/personal-access-token-create'));
const ValidateEmail = asyncComponent(async () => import('./components/validate-email'));

export default {
  '/login': {
    components: { topBar: null, main: Login }
  },
  '/login-cli-complete': {
    components: { main: LoginCliComplete }
  },
  '/logout': {
    components: { main: Logout }
  },
  '/signup': {
    components: { topBar: null, main: Signup }
  },
  '/reset-password': {
    components: { topBar: null, main: ResetPassword }
  },
  '/forgot-password': {
    components: { topBar: null, main: ForgotPassword }
  },
  '/check-email': {
    components: { topBar: null, main: CheckEmail }
  },
  '/account-settings': {
    components: { main: AccountSettings }
  },
  '/personal-access-tokens': {
    components: { main: PersonalAccessTokens },
    '/create': {
      components: { main: PersonalAccessTokenCreate }
    }
  },
  '/validate-email': {
    components: { main: ValidateEmail }
  }
};
